<template>
    <div>
        <app-toolbar :toolbar="toolbar"></app-toolbar>
        <v-container fluid>
        <!-- mainTable Start -->
            <v-simple-table class="mainTable" fixed-header height="75vh">
                <thead>
                    <tr>
                        <!-- <th> NAME </th> -->
                        <th v-show="editMode" width="20"></th>
                        <th v-show="editMode" width="20">EDIT</th>
                        <th> HOUSE TYPE </th>
                        <th> FIRE PROTECTION (防火仕様)</th>
                        <th> HEAVY SNOW (豪雪仕様)</th>
                        <th> KANABAKARI (矩計)</th>
                        <th> WATERTIGHT (耐水害住宅)</th>
                        <th> EARTHQUAKE RESISTANCE (２倍耐震)</th>
                        <th> HIGH FIRE PROOF OUTERWALL (高防火外壁)</th>
                        <th> SEISMIC ISOLATION (免震)</th>
                        <th v-show="viewMode"> CREATED </th>
                        <th v-show="viewMode"> UPDATED </th>
                        <th v-show="viewMode"> CREATED BY </th>
                        <th v-show="viewMode"> UPDATED BY </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in HOUSE_TYPE_GROUPS" :key="i" style="text-align:center;">
                        <td v-show="editMode">
                            <v-checkbox v-model="item.selected" dense></v-checkbox>
                        </td>
                        <td v-show="editMode"> 
                            <v-btn
                                fab
                                x-small
                                @click="toggleUpdateDialog(item)">
                                <v-icon >mdi-pencil</v-icon> 
                            </v-btn>
                        </td>
                        <td>
                            <v-chip class="font-weight-bold mx-1" small v-for="(SUBITEM,ii) in item.grouphouse" :key="`${i}-${ii}`">
                                {{ SUBITEM.grouphouse }}
                            </v-chip>
                        </td>
                        <td>
                            <v-icon color="green" v-if="item.fire_protection == '1'">
                                mdi-check-bold
                            </v-icon>
                            <v-icon color="red" v-else-if="item.fire_protection == null">
                                mdi-close-thick
                            </v-icon>
                        </td>
                        <td>
                            <v-icon color="green" v-if="item.heavy_snow == '1'">
                                mdi-check-bold
                            </v-icon>
                            <v-icon color="red" v-else-if="item.heavy_snow == null">
                                mdi-close-thick
                            </v-icon>
                        </td>
                        <td>
                            <v-icon color="green" v-if="item.kanabakari == '1'">
                                mdi-check-bold
                            </v-icon>
                            <v-icon color="red" v-else-if="item.kanabakari == null">
                                mdi-close-thick
                            </v-icon>
                        </td>
                        <td>
                            <v-icon color="green" v-if="item.water_tight == '1'">
                                mdi-check-bold
                            </v-icon>
                            <v-icon color="red" v-else-if="item.water_tight == null">
                                mdi-close-thick
                            </v-icon>
                        </td>
                        <td>
                            <v-icon color="green" v-if="item.earth_quake_resistance == '1'">
                                mdi-check-bold
                            </v-icon>
                            <v-icon color="red" v-else-if="item.earth_quake_resistance == null">
                                mdi-close-thick
                            </v-icon>
                        </td>
                        <td>
                            <v-icon color="green" v-if="item.high_fire_proof_outer_wall == '1'">
                                mdi-check-bold
                            </v-icon>
                            <v-icon color="red" v-else-if="item.high_fire_proof_outer_wall == null">
                                mdi-close-thick
                            </v-icon>
                        </td>

                        <td>
                            <v-icon color="green" v-if="item.seismic_isolation == '1'">
                                mdi-check-bold
                            </v-icon>
                            <v-icon color="red" v-else-if="item.seismic_isolation == null">
                                mdi-close-thick
                            </v-icon>
                        </td>
                        <td v-show="viewMode">{{ formatDate(item.created_at) }}</td>
                        <td v-show="viewMode">{{ formatDate(item.updated_at) }}</td>
                        <!-- <td v-show="viewMode">{{item.created_by}}</td>
                        <td v-show="viewMode">{{item.updated_by}}</td> -->
                    </tr>
                </tbody>
            </v-simple-table>
        <!-- mainTable End -->

            
        </v-container>

        <!-- Dialogs -->
        <!-- dialogStore Start -->
        <v-dialog v-model="dialogStore" max-width="300" persistent>
            <v-form id="Store" ref="Store" @submit.prevent="Store">
                <v-card>
                    <v-card-title> <span class="overline">Create House Type Group</span> </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-autocomplete
                                        :items="HOUSE_TYPES"
                                        item-value="id"
                                        item-text="name"
                                        outlined 
                                        multiple 
                                        label="House Type"
                                        name="house_type_id" 
                                        class="required"
                                        :rules="rules.required"
                                        chips
                                        small-chips
                                        deletable-chips> 
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox 
                                        label="Fire Protection (防火仕様)" 
                                        v-model="fireProtection" 
                                        name="fire_protection"
                                        value="1">
                                    </v-checkbox>
                                    <!-- <v-autocomplete 
                                        outlined 
                                        dense 
                                        label="Fire Protection"
                                        name="fire_protection" 
                                        :items="fireProtectionList"
                                        item-text="text"
                                        item-value="value"
                                        class="required"
                                        :rules="rules.required"
                                    > </v-autocomplete> -->
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox 
                                        label="Heavy Snow (豪雪仕様)" 
                                        v-model="heavySnow" 
                                        name="heavy_snow"
                                        value="1">
                                    </v-checkbox>
                                    <!-- <v-autocomplete
                                        outlined
                                        dense
                                        :items="ariNashi"
                                        label="Heavy Snow"
                                        name="heavy_snow"
                                        item-text="text"
                                        item-value="value"
                                        class="required"
                                        :rules="rules.required">
                                    </v-autocomplete> -->
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox 
                                        label="Kanabakari (矩計)" 
                                        v-model="kanabakari" 
                                        name="kanabakari"
                                        value="1">
                                    </v-checkbox>
                                    <!-- <v-autocomplete
                                        outlined 
                                        dense
                                        :items="kanabakari"
                                        item-text="text"
                                        item-value="value"
                                        label="Kanabakari"
                                        class="required"
                                        :rules="rules.required">
                                    </v-autocomplete> -->
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox 
                                        label="Watertight (耐水害住宅)" 
                                        v-model="watertight" 
                                        name="water_tight"
                                        value="1">
                                    </v-checkbox>
                                    <!-- <v-autocomplete
                                        outlined
                                        dense
                                        :items="watertightList"
                                        item-text="text"
                                        item-value="value"
                                        label="Watertight"
                                        name="water_tight"
                                        class="required"
                                        :rules="rules.required">
                                    </v-autocomplete> -->
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox 
                                        label="Double Earth Resistance (２倍耐震)" 
                                        v-model="doubleEarthQuake" 
                                        name="double_earthquake_resistance"
                                        value="1">
                                    </v-checkbox>
                                    <!-- <v-autocomplete
                                        outlined
                                        dense
                                        :items="ariNashi"
                                        item-text="text"
                                        item-value="value"
                                        label="Double Earth Resistance"
                                        name="double_earthquake_resistance"
                                        class="required"
                                        :rules="rules.required">
                                    </v-autocomplete> -->
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox 
                                        label="High Fireproof Outer Wall (高防火外壁)" 
                                        v-model="highfireProof" 
                                        name="high_fireproof_outer_wall"
                                        value="1">
                                    </v-checkbox>
                                    <!-- <v-autocomplete
                                        outlined
                                        dense
                                        :items="ariNashi"
                                        item-text="text"
                                        item-value="value"
                                        label="High Fireproof OuterWall"
                                        name="high_fireproof_outer_wall"
                                        class="required"
                                        :rules="rules.required">
                                    </v-autocomplete> -->
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox
                                        label="Seismic Isolation (免震)"
                                        v-model="seismicIsolation"
                                        name="seismic_isolation"
                                        value="1">
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogStore = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogStore End -->

        <!-- dialogUpdate Start -->
        <v-dialog v-model="dialogUpdate" max-width="300" persistent>
            <v-form id="Update" ref="Update" @submit.prevent="Update">
                <v-card>
                    <v-card-title> <span class="overline">Edit House Type Group</span> </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-autocomplete
                                        v-model="tempData.house_type_id"
                                        :items="HOUSE_TYPES"
                                        item-value="id"
                                        item-text="name"
                                        outlined 
                                        multiple 
                                        label="House Type"
                                        name="house_type_id" 
                                        class="required"
                                        :rules="rules.required"
                                        chips
                                        small-chips
                                        deletable-chips> 
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox 
                                        label="Fire Protection" 
                                        v-model="tempData.fire_protection" 
                                        name="fire_protection"
                                        value="1">
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox 
                                        label="Heavy Snow" 
                                        v-model="tempData.heavy_snow" 
                                        name="heavy_snow"
                                        value="1">
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox 
                                        label="Kanabakari" 
                                        v-model="tempData.kanabakari" 
                                        name="kanabakari"
                                        value="1">
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox 
                                        label="Watertight" 
                                        v-model="tempData.water_tight" 
                                        name="water_tight"
                                        value="1">
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox 
                                        label="Double Earth Resistance" 
                                        v-model="tempData.earth_quake_resistance" 
                                        name="double_earthquake_resistance"
                                        value="1">
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox 
                                        label="High Fireproof Outer Wall" 
                                        v-model="tempData.high_fire_proof_outer_wall" 
                                        name="high_fireproof_outer_wall"
                                        value="1">
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox
                                        label="Seismic Isolation"
                                        v-model="tempData.seismic_isolation"
                                        name="seismic_isolation"
                                        value="1">
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogUpdate = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogUpdate End -->

        <!-- dialogDelete Start -->
        <v-dialog v-model="dialogDelete" max-width="300" persistent>
            <v-form id="Delete" ref="Delete" @submit.prevent="Delete">
                <v-card>
                    <v-card-title> <span class="overline">delete</span> </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="overline font-weight-black"> Delete Selected Items? </span>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit" >保存</v-btn>
                        <v-btn text @click="dialogDelete = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogDelete End -->

        <app-buttons  
            @toggleDialogDelete="toggleDialogDelete"
            @toggleDialogStore="toggleDialogStore" 
            :selectedData="selectedData"
            :floatButtons="floatButtons"
        > 
        </app-buttons>
        <app-footer ></app-footer>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import ToolbarMenu from '../../modules/ToolbarMenu.vue';
import Footer from '../../modules/Footer.vue';
import FloatingButtons from '../../modules/FloatingButtons.vue';
export default {
    components: {
            'app-toolbar': ToolbarMenu,
            'app-buttons': FloatingButtons,
            'app-footer': Footer
        },
        data: () => ({
            toolbar: {
                title: 'HOUSE TYPE GROUP',
                view: true,
                back: true,
                filter: false,
                master: false,
            },

            floatButtons:{
                add: true,
                update: true,
                delete: true
            },

            tempData: {},
            
            fireProtection : null,
            heavySnow : null,
            kanabakari : null,
            watertight : null,
            doubleEarthQuake : null,
            highfireProof : null,
            seismicIsolation : null,

            
            dialogStore: false,
            dialogUpdate: false,
            dialogDelete: false,

            // fireProtectionList: [
            //  {value: '1', text: 'なし'},
			// 	{value: '2', text: '準防火仕様'},
			// 	{value: '3', text: '準耐火仕様'}
            // ],
            // kanabakari: [
			// 	{value: '240', text: '240'},
			// 	{value: '260+', text: '260+'},
			// 	{value: '265', text: '265'}
			// ],
            // ariNashi: [
			// 	{value:'1', text: 'あり'},
			// 	{value:'0', text: 'なし'}
			// ],
            // watertightList :[
            //     {value: 'なし', text: 'なし'},
            //     {value: '耐水害（ｽﾀﾝﾀﾞｰﾄﾞ)' , text: '耐水害（ｽﾀﾝﾀﾞｰﾄﾞ)'},
            //     {value: '耐水害（浮上)', text: '耐水害（浮上)'}
            // ],
        }),

        computed : {
            ...mapState([
                'HOUSE_TYPE_GROUPS',
                'HOUSE_TYPES',
                'rules',
                'viewMode',
                'editMode'
            ]),

            selectedData(){
                // this will return only the id of the selected data
                return this.HOUSE_TYPE_GROUPS.filter(res => res.selected).map(res => res.id); 
            },
        },

        methods: {
            ...mapActions([
                '_getHouseTypes',
                '_getHouseTypeGroups',
            ]),

            formatDate(val){
                return new Date(val).toLocaleString('en-US', { timeZone: 'Asia/Manila', hour12: false })
            },

            toggleDialogDelete(val){
                this.dialogDelete = val;
            },

            toggleDialogStore(val){
                this.dialogStore = val;
            },

            toggleUpdateDialog(item){
                // console.log(item)
                if(item){
                    this.tempData = {...item};
                    this.tempData.house_type_id = this.tempData.grouphouse.map(res => res.house_type_id)
                    this.dialogUpdate = true;
                }else{
                    this.dialogUpdate = false;
                }
            },

            Delete(){
                axios({
                    method: 'POST',
                    url: '/api/house_type_group/delete',
                    data: {ids : this.selectedData}
                }).then(() => {
                    this._getHouseTypeGroups();
                    this.dialogDelete = false;
                })
            },

            Update(){
                if(this.$refs.Update.validate()){
                    const myForm = document.getElementById('Update');
                    const formdata = new FormData(myForm);
                    const id = this.tempData.id

                    axios({
                        method: 'POST',
                        url: `/api/house_type_group/update/${id}`,
                        data: formdata
                    }).then(() => {
                        this._getHouseTypeGroups();
                        this.$refs.Update.resetValidation();
                        this.$refs.Update.reset();
                        this.dialogUpdate = false;
                    })
                }
            },

            Store(){
                if(this.$refs.Store.validate()){
                    const myForm = document.getElementById('Store');
                    const formdata = new FormData(myForm);

                    axios({
                        method: 'POST',
                        url: '/api/house_type_group/store',
                        data: formdata
                    }).then(() => {
                        this._getHouseTypeGroups();
                        this.$refs.Store.resetValidation();
                        this.$refs.Store.reset();
                        this.dialogStore = false;
                    })
                }
            },
        },

        mounted() {
            this._getHouseTypeGroups().then(() => {
                this._getHouseTypes();
            })
        }
}
</script>